import axios from 'CanExConfig/axios'

export const fetchCalendarStatus = async id => {
  const response = await axios(`/api/candidate/profiles/${id}/calendar_status`, {
    method: 'get',
  })

  return response.data
}
